import { Component, input } from '@angular/core';
import { NAV_ROUTES } from '@navfleet/client/navigation/domain/models';
import { NavRouterLinkDirective } from '@navfleet/client/navigation/utils';
import { IconContainer } from '@navfleet/client/shared/components/icon/ui';
import { TooltipOverflowOnlyDirective } from '@navfleet/client/shared/ui/tooltip-trigger';
import { LAYOUT_NOTIFICATION_DROPDOWN_CONFIG, LayoutNotification } from '@navfleet/client/shell/domain/models';
import { TranslationModule } from '@navfleet/shared/core/translation';
import { TooltipModule } from '@openng/optimus-ui/tooltip';

@Component({
    imports: [TranslationModule, IconContainer, TooltipOverflowOnlyDirective, TooltipModule, NavRouterLinkDirective],
    selector: 'fl-top-menu-notifications-list',
    templateUrl: './top-menu-notifications-list.component.html',
    styleUrls: ['./top-menu-notifications-list.component.scss'],
})
export class TopMenuNotificationsListComponent {
    public readonly notificationDropdownConfig = LAYOUT_NOTIFICATION_DROPDOWN_CONFIG;
    public readonly NAV_ROUTES = NAV_ROUTES;

    public readonly notifications = input<LayoutNotification[]>([]);
}
